<h3 style="text-align: center;
font-size: 32px;
font-weight: bold;
margin-bottom: 40px; ">Time Management</h3>

<!-- my-alternate-theme: the app theme is mat-dark-theme, so Material panels render
     dark; this is the same light-theme wrapper the schedule page uses. -->
<div class="pto-section my-alternate-theme" *ngIf="showPtoPanel">
  <app-pto-panel [employeeId]="ptoEmployeeId"
                 [rangeDays]="14"
                 title="Upcoming Time Off (BambooHR)">
  </app-pto-panel>
</div>


<!--The repeatable card-->
<div id="main-div">

  <div class="toolbarBar">
    <div class="toolbarDiv">

      <div id="namesearch" class="toolbarField">
        <p class="toolbarFieldLabel">Name</p>
        <mat-form-field appearance="outline">
          <mat-label>Search</mat-label>
          <input matInput [(ngModel)]="searchTerm" placeholder="Name">
          <button *ngIf="searchTerm" matSuffix mat-icon-button aria-label="Clear" (click)="searchTerm=''">
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
      </div>

      <div id="datepicker" class="toolbarField">
        <p class="toolbarFieldLabel">Reference Date</p>
        <mat-form-field appearance="outline">
          <mat-label>Date</mat-label>
          <input matInput [matDatepicker]="picker" (dateChange)="dateChange($event)" [(ngModel)]="selectedDate">
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
      </div>

      <div *ngIf="dateSelected" @fadeIn>
        <p style="
        padding-right: 20px;
        margin-bottom: 0px;
        font-size: 20px;
        font-weight: 500;
        color: #424242;
        height: 48px;
        align-content: center;">Timecards will now reflect reference date.</p>
      </div>

      <div *ngIf="dateSelected" @fadeIn>
        <button class="clearDateButton" (click)="clearDate()">Reset to Today</button>
      </div>

    </div>
  </div>


  <div style="display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;">


      <div *ngFor="let employee of filteredEmployees" style="height:420px; width:300px; background: white; border-radius: 8px; position:relative; margin:20px;border: 1px solid #eaeaea; ">
        <div>
          <p *ngIf="!dateSelected" style="font-size: 40px;
          color: #dddddd;
          position: relative;
          left: 10px;">{{employee.totaltime}}</p>


          <p *ngIf="!dateSelected" style="font-size: 20px;
          /* transform: rotate(90deg); */
          position: absolute;
          /* bottom: 222px; */
          color: #dddddd;
          left: 10px;
          letter-spacing: 2px;
          top: 45px;">hours</p>
          <div style="width: 150px; height: 150px; border-radius: 50%; background-color: rgb(212, 212, 212);
          position: absolute; top: 30px; bottom: 200px; left: 65px; right: 65px; margin: auto;">

          <img [src]="getAvatarUrl(employee.employee_name)" style="width: 150px; height: 150px; border-radius: 50%; position: absolute; top: 0px; bottom: 0px; left: 0px; right: 0px; margin: auto;">

          <!--<span *ngFor="let daystatus of daystatuses"> -->
            <span *ngIf="employee.did != null && !dateSelected" style="position: absolute;
            color: lightseagreen;
            font-size: 15px;
            top: 130px;
            left: 150px;">
              {{  getTimeZoneDate(employee.daystart, false) }}
            </span>
          <!--</span> -->

            <span *ngIf="employee.did != null && !dateSelected" style="color: red;
            font-size: 15px;
            position: absolute;
            left: 150px;
            top: 150px;">
              {{ getTimeZoneDate(employee.dayend, false) }}
            </span>

        </div>
        </div>
          <div style="width: 200px; height: 35px;  position: absolute; top: 190px; bottom: 145px; left: 50px; right: 50px; margin: auto;">
            <p style="text-align: center;
            font-size: 24px;
            letter-spacing: 0.2px;
            font-weight: bold;
            color: #424242;">{{employee.employee_name}} </p>

          </div>
          <div *ngIf="employee.street_address && !employee.ispaused" style="width: 260px; height: 60px;  position: absolute; top: 285px; bottom: 70px; left: 20px; right: 20px;">
            <div><p style="text-align: center;
              font-size: 12px;
              color: #d4d4d4;
              margin-bottom: 0 !important;">Currently At</p></div>
            <div><p style="    text-align: center;
              font-size: 12px;
              color: dimgray;
              font-weight: 500;">{{employee.street_address}}</p>
              <p style="    text-align: center;
              font-size: 12px;
              color: dimgray;
              font-weight: 500;
              position: relative;
              bottom: 10px;">{{employee.subdivision_name}}-{{employee.lot}}</p></div>

          </div>

          <div *ngIf="!employee.street_address && !employee.ispaused" style="width: 260px; height: 60px;  position: absolute; top: 285px; bottom: 70px; left: 20px; right: 20px;">
            <div><p style="text-align: center;
              font-size: 18px;
              color: #d4d4d4;
              margin-bottom: 0 !important;">Not clocked in</p></div>

          </div>

          <div *ngIf="employee.ispaused" style="width: 260px; height: 60px;  position: absolute; top: 285px; bottom: 70px; left: 20px; right: 20px;">
            <div><p style="text-align: center;
              font-size: 18px;
              color: #d4d4d4;
              margin-bottom: 0 !important;">Paused.</p></div>

          </div>

          <div>
            <button  (click)="openSchedule(employee.employeeid)" class="cardButton">
              Schedule
            </button>

            <button (click)="viewTimecard(employee.employeeid)" class="cardButton2">
              Timecard
            </button>
          </div>

      </div>


  </div>


</div>
